import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ClearDataService = {
  /**
   * Clear all data with password verification
   * @param {string} password - Admin password for verification
   * @param {boolean} takeBackup - Whether to take backup before clearing (default: false)
   */
  clearAllData: async (password, takeBackup = false) => {
    try {
      const params = new URLSearchParams({
        password: password,
        TakeBackUp: takeBackup.toString(),
      });

      const response = await apiService.delete(
        `/ordermaintenance/clear-all?${params.toString()}`,
        {
          headers: {
            Authorization: "Bearer " + _BaseAPIService.retrieveToken(),
          },
        },
      );
      return response.data;
    } catch (error) {
      console.error("Error clearing data:", error);
      throw error;
    }
  },
};

export default ClearDataService;
